import formatName, { formatNameWithParts } from './format-name';
export default function fullName(person, {
  isJP
}) {
  return formatName(person, (first, last) => {
    if (isJP) {
      return `${last} ${first}`;
    } else {
      return `${first} ${last}`;
    }
  });
}
export function fullNameWithParts(nullableFirst, nullableLast, {
  isJP
}) {
  return formatNameWithParts(nullableFirst, nullableLast, (first, last) => {
    if (isJP) {
      return `${last} ${first}`;
    } else {
      return `${first} ${last}`;
    }
  });
}